var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4966 13.1237C14.6391 13.1237 13.124 14.6387 13.124 16.4962C13.124 18.3539 14.6391 19.869 16.4966 19.869C18.3543 19.869 19.8693 18.3539 19.8693 16.4964C19.8693 14.6387 18.3543 13.1237 16.4966 13.1237Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0283 8.22266H11.9643C9.90894 8.22266 8.22266 9.89589 8.22266 11.9643V21.0283C8.22266 23.0836 9.89573 24.7699 11.9643 24.7699H21.0283C23.0836 24.7699 24.7699 23.0967 24.7699 21.0283V11.9643C24.7567 9.89589 23.0836 8.22266 21.0283 8.22266ZM16.4962 21.5684C13.69 21.5684 11.4109 19.2893 11.4109 16.4832C11.4109 13.677 13.69 11.3977 16.4962 11.3977C19.3025 11.3977 21.5816 13.677 21.5816 16.4832C21.5684 19.2893 19.2893 21.5684 16.4962 21.5684ZM21.9373 12.2541C21.2654 12.2541 20.7122 11.7007 20.7122 11.0288C20.7122 10.3569 21.2654 9.80359 21.9373 9.80359C22.6092 9.80359 23.1626 10.3569 23.1626 11.0288C23.1626 11.7139 22.6224 12.2541 21.9373 12.2541Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.496 1.27954C8.09064 1.27954 1.2793 8.09088 1.2793 16.4962C1.2793 24.9017 8.09064 31.7129 16.496 31.7129C24.9014 31.7129 31.7126 24.9017 31.7126 16.4962C31.6996 8.09088 24.8882 1.27954 16.496 1.27954ZM26.4692 21.0283C26.4692 24.0321 24.0187 26.4826 21.015 26.4826H11.964C8.9602 26.4826 6.50971 24.0321 6.50971 21.0283V11.9643C6.50971 8.96044 8.9602 6.50995 11.964 6.50995H21.0281C24.0319 6.50995 26.4824 8.96044 26.4824 11.9643V21.0283H26.4692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.438f462842c2a12f8f98237b9018a8c1.svg";
export { ForwardRef as ReactComponent };